import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=8afe2368&"
import script from "./NotFoundPage.vue?vue&type=script&lang=js&"
export * from "./NotFoundPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports